// Multi-month plan pricing helper — mirrors backend `_plan_monthly_price`.
// base = the listed monthly price (equivalent to the 3-month commitment tier).
export const PLANS = [
  { id: '1mo',  months: 1,  label: 'Monthly',       note: 'No commitment',       badge: null },
  { id: '3mo',  months: 3,  label: '3-Month Plan',  note: 'Billed every 3 months',  badge: null },
  { id: '6mo',  months: 6,  label: '6-Month Plan',  note: 'Billed every 6 months',  badge: null },
  { id: '12mo', months: 12, label: '12-Month Plan', note: 'Billed every 12 months', badge: null },
];

export function planMonthlyPrice(base, planId) {
  if (!base) return null;
  if (planId === '1mo')  return Math.round(base * 1.45);  // premium — no commitment
  if (planId === '6mo')  return Math.max(0, Math.round(base * 0.92));
  if (planId === '12mo') return Math.max(0, Math.round(base * 0.85));
  return base; // 3mo — the anchor price
}

// Total up-front price if the user pays the whole plan today.
export function planTotalPrice(base, planId) {
  const monthly = planMonthlyPrice(base, planId);
  const months = PLANS.find((p) => p.id === planId)?.months || 1;
  return monthly * months;
}

// Savings vs. paying the 1-month rate for the same length of time.
export function planSavings(base, planId) {
  if (planId === '1mo') return 0;
  const oneMoRate = planMonthlyPrice(base, '1mo');
  const months = PLANS.find((p) => p.id === planId)?.months || 1;
  return Math.max(0, (oneMoRate * months) - planTotalPrice(base, planId));
}

export function formatMoney(n) {
  if (n === null || n === undefined) return '—';
  return `$${n}`;
}
